//HistoryTable.js
import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Tooltip,
  Paper
} from '@mui/material';

import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { qualtiyColorScheme } from './resultUtils';
import { InfoLingua } from './InfoLingua';
const HistoryTable = ({ in_data, 
                        bestScore, 
                        playFromStorage, 
                        langLearn, 
                        langBase, 
                        explain = true,
                        rowCount = 20, 
                        showHeader = true 
                        }) => {
  const data = JSON.parse(JSON.stringify(in_data));
  const data_reverse = [...data.slice(-rowCount)].reverse();
  const data_view = [];
  const bScore = bestScore ? JSON.parse(JSON.stringify(bestScore)) : {};

  const extractNumberInParentheses = (str) => {
    const match = str.match(/\((\d+)\)/);
    return match ? parseInt(match[1], 10) : null;
  };

  const formatData = (rec) => {
    const newRec = {};
    let quality = parseInt((rec['confidence'] * 100).toFixed(0));
    let time = rec['duration'];
    let lost_words = rec['lost'];
    let lowest_score = rec['weak'];
    let lscore = extractNumberInParentheses(lowest_score);

    if (lscore === quality || quality === 0) {
      lowest_score = '';
    }

    newRec['quality'] = `${quality}%`;
    newRec['time'] = time;
    newRec['missed words'] = lost_words;
    newRec['lowest score'] = lowest_score.replace(/\((\d+)\)/, '$1%');;
    data_view.push(newRec);
  };


  data.forEach(formatData);

  const keys = data_view.length > 0 ? Object.keys(data_view[0]) : [];
  const ind_view = data_view.length - bScore['indBest'] - 1;

  const tooltips = [
    'Average quality. It ranges from 0 to 100\n It is determined by AI. \n It is 0 when any input word is unrecognized',
    'Duration of your speech. \nCompare it with the duration of the speech \ngenerated by AI',
    'Input words missing in your speech',
    'The word with the lowest quality score'
  ];

  const bgkColor = (item, index, key) => {
    let q = (data_reverse[index].confidence*100).toFixed(0)
    return qualtiyColorScheme(q);
  };

  const handleIconClick = () => {
    playFromStorage(bScore['fpathMaxscore']);
  };

  const prepareForExplain = (key, txt) => {
    if (key === 'lowest score') {
      return txt.trim().split(/\s+/)[0];
    }
    if (key === 'missed words') {
      return txt;
    }
  }
  return (
    <TableContainer component={Paper} elevation={3} sx = {{width:'100%'}}>
      <Table sx={{ width: '100%'}} aria-label="history table">
        {showHeader && (
          <TableHead>
            <TableRow>
              {keys.map((key, index) => (
                <Tooltip key={index} title={tooltips[index]}>
                  <TableCell sx={{ fontWeight: 'bold', padding: '4px', border: '1px solid black' }}>
                    {key}
                  </TableCell>
                </Tooltip>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {data_view.slice(-rowCount).reverse().map((item, index) => (
            <TableRow key={index} sx={{ backgroundColor: index === 0 ? '#FFFFE0' : 'inherit' }}>
              {keys.map((key, idx) => (
                <TableCell 
                  key={idx} 
                  sx={{
                    border: '1px solid black',
                    padding: '4px',
                    backgroundColor: bgkColor(item, index, key),
                    wordBreak: 'break-word'
                  }}
                >
                  {key === 'quality' && index === ind_view && index !== 0 ? (
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2">{item[key]}</Typography>
                      <IconButton onClick={handleIconClick} size="small" sx={{ ml: 1 }}>
                        <VolumeUpIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ) : (
                    (explain && (
                          (key === 'lowest score' && item[key].trim() !== '') || 
                          (key === 'missed words' && item[key] !== 'None')) )? <InfoLingua
                      inputText = {prepareForExplain(key, item[key])}
                      expl_type="pronunciation (detailed)"
                      expl_style="detailed"
                      langLearn={langLearn}
                      langBase={langBase}
                      label={item[key]}
                      labelAlignment="right"
                      verticalAlign = {true}
                      textOnly = {true}
                    />:
                    typeof item[key] === 'number' ? item[key].toFixed(2) : item[key]
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HistoryTable;
